<template>
  <asc-dialog
    :text="title"
    :show-dialog="showDialog"
    :on-close="handleClose"
    :width="1000"
  >
    <template v-if="showDialog">
      <asc-raw-report
        :report-text="reportText"
        :loading="loading"
      ></asc-raw-report>
    </template>
  </asc-dialog>
</template>

<script>
import { AscRawReportMixin, AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscRawReport from './AscRawReport'

export default {
  name: 'AscRawReportDialog',

  components: {
    AscRawReport,
    AscDialog,
  },

  mixins: [AscRawReportMixin, AscDialogMixin],
}
</script>
